export const JOBS_CONTRACTS = [
  {
    code: "extra",
    label: "CORE.MODELS.CONTRACTS.@AE",
    color: "secondary",
  },
  {
    code: "interim",
    label: "CORE.MODELS.CONTRACTS.@INTERIM",
    color: "interim-green",
  },
  {
    code: "cdi",
    label: "CORE.MODELS.CONTRACTS.@CDI",
    color: "primary",
  },
  {
    code: "saisonnier",
    label: "CORE.MODELS.CONTRACTS.@SEASON",
    color: "season-orange",
  },
];

export const JOBS_CONTRACTS_TYPE = {
  CDI: "cdi",
  SEASON: "saisonnier",
  INTERIM: "interim",
  AE: "auto_e",
  EXTRA: "extra",
};

export const JOBS_GOOGLE_JOBS = {
  FULL_TIME: "FULL_TIME",
  PART_TIME: "PART_TIME",
};

export const JOBS_APPLICATION_STATUS = {
  DOWNLOAD: "download",
  OPEN_APPLY: "openapply",
  APPLY: "apply",
};

export const JOBS_QUALIFS = [
  {
    id: 25,
    label: "Chef de rang",
    value: "chef-de-rang",
    city: ["paris", "lyon"],

    texts: {
      title: {
        paris: "Emploi Chef de Rang à Paris (75) ",
        lyon: "Emploi chef de Rang à Lyon - CDI, missions, intérim",
      },
      h1: {
        paris: "Emploi Chef de Rang à Paris - Opportunités CDI, missions, intérim",
        lyon: "Emploi Chef de Rang à Lyon - CDI, intérim, Extras",
      },
      h2: {
        paris: "Explorez les Offres de Chef de Rang à Paris",
        lyon: "Travailler comme Chef de Rang à Lyon ",
      },
      description: {
        paris:
          "Découvrez une sélection d'annonces pour des postes de Chef de Rang dans les meilleurs établissements de Paris. Que vous recherchiez un CDI, un contrat d'intérim ou une mission freelance, trouvez l'emploi idéal adapté à vos compétences et à vos ambitions. Extracadabra est la seule plateforme à vous proposer ces différentes opportunités. Postulez dès maintenant pour une carrière enrichissante dans la restauration.",
        lyon: "Lyon est riche en gastronomie, elle offre un cadre prestigieux pour les Chefs de Rang. Ce poste est une excellente opportunité pour ceux qui souhaitent se distinguer dans l'industrie de la restauration et progresser dans leur carrière. Extracadabra est la seule plateforme à proposer des offres de CDI, des contrat en intérim et des prestations freelance, postulez !",
      },
      metaDesc: {
        paris:
          "Actuellement des annonces disponibles de serveur dans les meilleurs établissements parisiens. Postulez-vite ! CDI, Intérim, Freelance",
        lyon: "Offres d'emploi de Chef de Rang dans les meilleurs restaurants lyonnais. Postulez dès maintenant !",
      },
    },
  },
  {
    id: 2,
    label: "Serveur",
    value: "serveur",
    city: ["paris", "lyon"],
    texts: {
      title: {
        paris: "Emploi Serveur à Paris - CDI, missions, intérim",
        lyon: "Emploi Serveur à Lyon (69)",
      },
      h1: {
        paris: "Emploi Serveur à Paris - Opportunités en CDI, intérim et freelance",
        lyon: "Trouvez un Emploi de Serveur à Lyon",
      },
      h2: {
        paris: "Travailler Comme Serveur à Paris : Une Expérience Unique",
        lyon: "Opportunités de CDI, missions et Intérim pour Serveurs ",
      },
      description: {
        paris:
          "En tant que serveur, vous aurez l'opportunité de travailler dans des établissements prestigieux, allant des bistrots traditionnels aux restaurants étoilés à Paris. Ce rôle vous permettra de développer des compétences en service client et de vivre une expérience professionnelle enrichissante.",
        lyon: "Travailler comme serveur à Lyon offre une expérience enrichissante dans une ville reconnue pour sa scène culinaire vivante. Vous aurez la chance de travailler dans des établissements emblématiques, de perfectionner vos compétences en service et d'interagir avec une clientèle internationale. Ce poste est une excellente opportunité pour développer votre carrière dans un environnement stimulant et prestigieux, tout en bénéficiant d'une immersion dans la culture gastronomique lyonnaise.",
      },
      metaDesc: {
        paris: "Offres d'emploi de Serveur dans les meilleurs restaurants parisiens. Postulez dès maintenant !",
        lyon: "A Lyon, des offres de serveurs actuellement disponibles. CDI, Missions, Extras, Intérim. Postulez-vite !",
      },
    },
  },
  {
    id: 12,
    label: "Second de cuisine",
    value: "second-de-cuisine",
    city: ["paris"],
    texts: {
      title: {
        paris: "Emploi Second de Cuisine à Paris ",
      },
      h1: {
        paris: "Trouvez un Emploi de Second de Cuisine à Paris - CDI, Intérim, Freelance",
      },
      h2: {
        paris: "Devenez Second de cuisine à Paris",
      },
      description: {
        paris:
          "Paris est une ville emblématique pour les arts culinaires, offrant une richesse gastronomique incomparable. En tant que Second de Cuisine, vous travaillerez aux côtés de chefs renommés, perfectionnerez vos techniques culinaires et participerez à l'élaboration de plats de haute qualité. Ce poste est une excellente occasion de progresser dans votre carrière et de développer une expertise reconnue.",
      },
      metaDesc: {
        paris: "Des annonces de Second de Cuisine sont à pourvoir. Postulez en un clic en CDI, Intérim ou missions freelance.",
      },
    },
  },
  {
    id: 11,
    label: "Chef de cuisine",
    value: "chef-cuisinier",
    city: ["paris", "lyon"],
    texts: {
      title: {
        paris: "Emploi Chef Cuisinier à Paris (75) ",
        lyon: "Emploi Chef Cuisinier à Lyon (69) - CDI, missions, intérim",
      },
      h1: {
        paris: "Devenez Chef Cuisinier dans les Meilleurs Restaurants de Paris",
        lyon: "Offres d'Emploi pour Chefs Cuisiniers à Lyon",
      },
      h2: {
        paris: "Avantages et Perspectives de Carrière pour les Chefs Cuisiniers à Paris",
        lyon: "Pourquoi Travailler comme Chef Cuisinier à Lyon ?",
      },
      description: {
        paris:
          "Découvrez les opportunités qui vous attendent dans la capitale mondiale de la gastronomie. En CDI, missions freelance ou intérim, les opportunités ne manquent pas à Paris ! C'est l'étape inévitable avant de progresser vers des postes de chef exécutif ou de lancer votre propre restaurant ",
        lyon: "Lyon est un véritable centre culinaire où les Chefs Cuisiniers peuvent s’épanouir dans un environnement stimulant et prestigieux. En tant que Chef Cuisinier, vous aurez l'opportunité de travailler avec des ingrédients locaux de haute qualité, de créer des plats innovants et de diriger une équipe en cuisine. Ce poste vous permettra de développer vos compétences dans un cadre réputé pour son excellence gastronomique et de faire partie d'une scène culinaire dynamique.",
      },
      metaDesc: {
        paris: "A la recherche d'un emploi de Chef Cuisinier à Paris ? Intérim, missions Freelance, CDI. Postulez rapidement en ligne !",
        lyon: "Les meilleures offres d'emploi de Chef cuisinier sont à pourvoir sur Extracadabra.com. Découvrez-les vite !",
      },
    },
  },
  {
    id: 187,
    label: "Boulanger",
    value: "boulanger",
    city: ["paris"],
    texts: {
      title: {
        paris: "Emploi Boulanger à Paris - CDI, missions, intérim",
      },
      h1: {
        paris: "Boulanger à Paris - Les meilleurs offres en CDI, Intérim et Extras",
      },
      h2: {
        paris: "Pourquoi Travailler comme Boulanger à Paris ?",
      },
      description: {
        paris:
          "Que vous cherchiez un CDI, une mission intérim ou un job freelance, nous avons des opportunités adaptées à votre expertise et à vos ambitions. Les meilleures offres dans les boulangeries de la capitale sont ici ! Postulez en un clic. ",
      },
      metaDesc: {
        paris: "Retrouvez toutes les annonces de CDI, missions ou intérim pour le poste de Boulanger à Paris sur Extracadabra. Postulez-vite !",
      },
    },
  },
  {
    id: 13,
    label: "Commis de cuisine",
    value: "commis-de-cuisine",
    city: ["paris"],
    texts: {
      title: {
        paris: "Emploi Commis de Cuisine à Paris",
      },
      h1: {
        paris: "Trouvez un Emploi de Commis de Cuisine à Paris",
      },
      h2: {
        paris: "Opportunités de Carrière pour Commis de Cuisine",
      },
      description: {
        paris:
          "Explorez une multitude d'offres pour des postes de Commis de Cuisine à Paris. Que vous soyez débutant ou expérimenté, nous avons des opportunités qui correspondent à vos compétences. Postulez pour un CDI, un contrat d'intérim ou des missions flexibles dans les établissements les plus prestigieux de la capitale.",
      },
      metaDesc: {
        paris:
          "Envie d'un poste de Commis de cuisine à Paris ? CDI, intérim, missions. Retrouvez les annonces des meilleurs établissements parisiens.",
      },
    },
  },
  {
    id: 8,
    label: "Barman",
    value: "barman",
    city: ["paris", "lyon"],
    texts: {
      title: {
        paris: "Emploi Barman à Paris - CDI, missions, intérim",
        lyon: "Offres d'Emploi Barman à Lyon - CDI, missions, intérim",
      },
      h1: {
        paris: "Offres d'Emploi pour Barmans",
        lyon: "Trouvez Votre Poste de Barman à Lyon - CDI, Missions, Intérim",
      },
      h2: {
        paris: "Avantages de Travailler comme Barman à Paris",
        lyon: "Annonces pour Barmans à Lyon",
      },
      description: {
        paris:
          "Explorez une multitude d'opportunités de carrière pour les barmans dans les établissements les plus prestigieux de Paris. Que vous soyez débutant ou un barman expérimenté, trouvez le poste qui correspond à vos compétences. Rejoignez une équipe dynamique et contribuez à créer des expériences inoubliables pour les clients. Postulez pour un CDI, un contrat d'intérim ou des missions freelance dès aujourd'hui !",
        lyon: "Découvrez une variété d'offres d'emploi pour le poste de Barman à Lyon, allant des CDI aux missions temporaires et contrats d'intérim. Explorez les meilleures annonces proposées par Extracadabra et trouvez un poste qui correspond à vos compétences et à vos ambitions. Postulez en un seul clic pour intégrer des établissements réputés et faire partie d'une scène nocturne animée.",
      },
      metaDesc: {
        paris: "Actuellement des annonces disponibles de Barman dans les meilleurs établissements parisiens. Postulez-vite !",
        lyon: "En recherche d'un poste de Barman à Lyon (69) ? Les meilleures annonces de Barman sont chez Extracadabra. Postulez en un seul clic !",
      },
    },
  },
  {
    id: 106,
    label: "Road",
    value: "road",
    city: ["paris"],
    texts: {
      title: {
        paris: "Offres d'Emploi Road à Paris (75)",
      },
      h1: {
        paris: "Offres d'Emploi Road à Paris - CDI, Intérim, Freelance",
      },
      h2: {
        paris: "Pourquoi Devenir Road ?",
      },
      description: {
        paris:
          "Le métier de Road à Paris offre une expérience unique dans le monde des événements et du spectacle. Vous serez au cœur de l'action, contribuant à l'organisation et au bon déroulement des événements musicaux, théâtraux et autres manifestations. Ce poste est idéal pour ceux qui aiment le travail en équipe, le dynamisme et les défis logistiques.",
      },
      metaDesc: {
        paris: "A la recherche d'un emploi de Road à Paris ? Intérim, missions Freelance, CDI. Postulez rapidement en ligne !",
      },
    },
  },
  {
    id: 49,
    label: "Vendeur",
    value: "vendeur",
    city: ["lyon"],
    texts: {
      title: {
        lyon: "Emploi Vendeur à Lyon (69)",
      },
      h1: {
        lyon: "Vendeurs à Lyon - les meilleures offres d'emploi",
      },
      h2: {
        lyon: "Rejoignez les Meilleurs Commerces de Lyon comme Vendeur",
      },
      description: {
        lyon: "Découvrez une large sélection d'offres d'emploi pour le poste de Vendeur dans les commerces de Lyon. Que vous recherchiez un CDI, un contrat d'intérim ou des missions freelance, nous avons des opportunités adaptées à tous les niveaux d'expérience. Postulez dès maintenant sur Extracadabra et trouvez le poste idéal pour développer vos compétences en vente et en service client.",
      },
      metaDesc: {
        lyon: "Actuellement des annonces disponibles de Vendeur dans les meilleurs établissements lyonnais. Postulez-vite ! CDI, Intérim, Freelance",
      },
    },
  },
  {
    id: 3,
    label: "Runner",
    value: "runner",
    city: ["lyon"],
    texts: {
      title: {
        lyon: "Emploi Runner à Lyon (69) - CDI, missions, intérim",
      },
      h1: {
        lyon: "Offres pour Runners à Lyon",
      },
      h2: {
        lyon: "Pourquoi Travailler comme Runner à Lyon ?",
      },
      description: {
        lyon: "Découvrez une large gamme d'opportunités pour le poste de Runner dans les restaurants les plus prestigieux de Lyon. Que vous soyez à la recherche d'un CDI, d'une mission ponctuelle ou d'un contrat intérim, nous avons des offres variées adaptées à vos compétences et à vos attentes. Postulez maintenant pour intégrer une équipe énergique et participer au bon déroulement du service dans la capitale gastronomique de la France.",
      },
      metaDesc: {
        lyon: "Des offres d'emploi de Runner dans les meilleurs restaurants lyonnais. Postulez dès maintenant !",
      },
    },
  },
  {
    id: 26,
    label: "Chef de partie",
    value: "chef-de-partie",
    city: ["lyon"],
    texts: {
      title: {
        lyon: "Emploi Chef de Partie à Lyon - CDI, missions, intérim",
      },
      h1: {
        lyon: "Postes de Chef de Partie à Lyon - CDI, Missions, Intérim",
      },
      h2: {
        lyon: "Pourquoi Choisir Lyon pour Votre Carrière de Chef de Partie ?",
      },
      description: {
        lyon: "En tant que Chef de Partie à Lyon, vous plongerez dans une scène culinaire vibrante où tradition et innovation se rencontrent. Ce rôle vous permettra de gérer des sections spécifiques en cuisine, de diriger une équipe de commis. Lyon, reconnue pour sa gastronomie, offre un cadre stimulant pour les professionnels souhaitant évoluer et relever des défis culinaires. .",
      },
      metaDesc: {
        lyon: "A Lyon, les meilleurs postes de Chefs de Partie sont chez Extracadabra. Postulez en un clic !",
      },
    },
  },
  {
    id: 58,
    label: "Employé polyvalent",
    value: "employe-polyvalent-restauration",
    city: ["lyon"],
    texts: {
      title: {
        lyon: "Emploi Employé Polyvalent Restauration Lyon",
      },
      h1: {
        lyon: "Rejoignez les Équipes de Restauration à Lyon comme Employé Polyvalent",
      },
      h2: {
        lyon: "Les Bénéfices de Travailler comme Employé Polyvalent en Restauration à Lyon",
      },
      description: {
        lyon: "Découvrez une variété d'opportunités pour le poste d'Employé Polyvalent en Restauration à Lyon. Nous proposons des offres en CDI, des missions ponctuelles et des contrats d'intérim dans les établissements les plus renommés de la ville. Postulez dès maintenant sur Extracadabra et intégrez une équipe dynamique où vos compétences variées seront mises à profit.",
      },
      metaDesc: {
        lyon: "A la recherche d'un emploi d'employé polyvalent en restauration à Lyon ? CDI, mission, Interim, les meilleures annonces sont chez Extracadabra. Postulez-vite !",
      },
    },
  },
];
